import { useCallback } from 'react';
import { Profile } from '@adapters/bigcommerce/operations/customer/updateProfile';
import { HookError } from '@adapters/bigcommerce/errorHandlers';

export const updateProfileFetcher = async (body: Profile): Promise<Profile> => {
  if (!body) {
    throw new HookError('body must be provided to update the customer');
  }
  const updateProfileResponse = await fetch('/api/customer/update-profile', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (updateProfileResponse.status !== 200) {
    throw new HookError('Response status is not 200');
  }

  const { data } = await updateProfileResponse.json();
  return data;
};

const useUpdateProfile = () =>
  useCallback(async (body: Profile) => {
    const data = await updateProfileFetcher(body);
    return data;
  }, []);

export default useUpdateProfile;
